import { timePeriodEnum } from 'app/pages/SalesPortalPage/LayoutV1/data/type';
import type { MetricsFrameworkPeriod } from '../types';

export type MetricsApiPeriodBody = {
  /** TimePeriodEnums code (e.g. LAST_MONTH) or CUSTOM with start/end. */
  time_period: string;
  start_date?: string;
  end_date?: string;
  param?: string;
};

/**
 * Maps UI time-period codes to metrics/insights API body params.
 * Passes TimePeriodEnums codes through (same codes as backend TimePeriodEnums).
 */
export const mapTimePeriodToApi = (
  period: MetricsFrameworkPeriod,
): MetricsApiPeriodBody => {
  if (period.startDate && period.endDate) {
    return {
      time_period: 'CUSTOM',
      start_date: period.startDate,
      end_date: period.endDate,
    };
  }

  const code = period.timePeriod || timePeriodEnum.LAST_MONTH;
  return { time_period: String(code).toUpperCase() };
};
